import React, { ReactNode } from 'react';
import { MdOutlineAssignmentTurnedIn } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { AiOutlineUser } from 'react-icons/ai';
import { Link, useLocation } from 'react-router-dom';
import { useIsLG } from '../../../utils/useResponsive';

export default function UserPanel() {
    const isLG = useIsLG();
    return isLG ? <UserPanelStandard /> : <UserPanelSmall />;
}

function UserPanelSmall() {
    const { t } = useTranslation();
    return (
        <div>
            <div
                className={
                    'flex w-full flex-col gap-1 rounded bg-slate-100 py-2 px-2 sm:w-fit sm:flex-row'
                }>
                <TabButtonSmall
                    path={'/my-account/profile'}
                    text={t('translation:MY_ACCOUNT.TAB.PROFILE')}
                    icon={<AiOutlineUser />}
                />
                <TabButtonSmall
                    path={'/my-account/my-reports'}
                    text={t('translation:MY_ACCOUNT.TAB.MY_REPORTS')}
                    icon={<MdOutlineAssignmentTurnedIn />}
                />
            </div>
            <hr className={'mt-3 border-SM-yellow bg-SM-yellow'} />
        </div>
    );
}

function TabButtonSmall(props: { text: string; icon: ReactNode; path: string }) {
    const location = useLocation();
    return (
        <Link to={props.path} className={'flex w-full items-center gap-1 sm:w-fit'}>
            <div
                className={`flex w-full items-center gap-2 rounded-md px-4 py-2 ${
                    location.pathname === props.path && 'bg-white shadow'
                }`}>
                <span className={'text-xl'}>{props.icon}</span>
                <span className={' whitespace-nowrap'}>{props.text}</span>
            </div>
        </Link>
    );
}

function UserPanelStandard() {
    const { t } = useTranslation();
    return (
        <div className={'relative flex max-w-[300px] flex-col gap-1'}>
            <div className={'mb-2 font-medium'}>{t('translation:MY_ACCOUNT.MY_ACCOUNT')}</div>
            <TabButton
                path={'/my-account/profile'}
                text={t('translation:MY_ACCOUNT.TAB.PROFILE')}
                icon={<AiOutlineUser />}
            />
            {/*<TabButton*/}
            {/*    active={props.tab === 'password'}*/}
            {/*    onClick={() => props.setTab('password')}*/}
            {/*    text={t('translation:MY_ACCOUNT.TAB.PASSWORD')}*/}
            {/*    icon={<MdPassword />}*/}
            {/*/>*/}
            <TabButton
                path={'/my-account/my-reports'}
                text={t('translation:MY_ACCOUNT.TAB.MY_REPORTS')}
                icon={<MdOutlineAssignmentTurnedIn />}
            />
            {/*TODO: Dodać zakładki dotyczące gmin*/}
        </div>
    );
}

function TabButton(props: { text: string; icon: ReactNode; path: string }) {
    const location = useLocation();
    return (
        <Link to={props.path} className={'group flex items-center gap-1'}>
            <div
                className={`h-6 w-1 rounded  ${location.pathname === props.path && 'bg-SM-yellow'}`}
            />
            <div
                className={`flex w-full items-center gap-2 rounded-lg px-3 py-1 group-hover:bg-gray-100 ${
                    location.pathname === props.path && 'bg-gray-100'
                }`}>
                <span className={'text-xl'}>{props.icon}</span>
                <span className={' whitespace-nowrap'}>{props.text}</span>
            </div>
        </Link>
    );
}
